import  {useEffect, useRef} from 'react';
import classes from '../clinicscreen.module.css';
import TimeAgo from 'timeago-react';

const MessageList = (props) => {
    var status = props.isRead ? 'Read' : 'Delivered';
    if (props.direction === 'left') {
        return (
            <li className={classes.message_li}>
                <div className={classes.message_wrapper}>
                    <span className={classes.author}>{props.patientName}</span>
                    <div className={classes.user_symbol}>
                        <div className={classes.user_img}>
                            <span className={classes.user_symbol_content}>P</span>
                        </div>
                    </div>
                    <div className={classes.message_container}>
                        <div className={classes.message_text}>
                            {props.type === "text" &&
                            <span>{props.text}</span>
                            }
                            {(props.type === "image" || props.type === "video" || props.type === "application") &&
                            <a href={props.text} target="_blank" rel="noopener noreferrer" alt="">
                                <p>{props.text}</p>
                            </a>
                            }
                            {props.type === "audio" &&
                            <div className={classes.audioBubbleright}>
                            <audio controls src={props.content}></audio>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={classes.message_time_left}>
                        <span className={classes.timestamp_span_left}><TimeAgo datetime={props.timestamp}/></span>
                        <span className={classes.read_span_left}>{status}</span>
                    </div>
                </div>
            </li>
        )
    } else {
        return (
            <li className={classes.message_li_right}>
                <div className={classes.message_wrapper_right}>
                    <span className={classes.author_right}>{props.doctorName}</span>
                    <div className={classes.user_symbol_right}>
                        <div className={classes.user_symbol_content_right}>
                            <span>
                                <img
                                    src={props.doctorImage}
                                    className={classes.user_img_right}
                                    alt=""
                                />
                            </span>
                        </div>
                        <div className={classes.message_container}>
                            <div className={classes.message_text_right}>
                                {props.type === "text" &&
                                <span>{props.text}</span>
                                }
                                {(props.type === "image" || props.type === "video" || props.type === "application") &&
                                <a href={props.text} target="_blank" rel="noopener noreferrer" alt="">
                                    <p>{props.text}</p>
                                </a>
                                }
                                {props.type === "audio" &&
                                <div className={classes.audioBubble}>
                                <audio controls src={props.text}></audio>
                                </div>
                            }
                            </div>
                        </div>
                        <div className={classes.message_time_right}>
                            <span className={classes.timestamp_span_right}><TimeAgo datetime={props.timestamp}/></span>
                            <span className={classes.read_span_right}>{status}</span>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

const ClinicalChatList = (props) => {
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        !props.loading_messages && messagesEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    const messages = props.messages.map(message => {
        return <MessageList
            key={message.receiveMessage.timestamp}
            type={message.receiveMessage.type}
            isRead={message.receiveMessage.isRead}
            direction={message.receiveMessage.direction}
            text={message.receiveMessage.content}
            timestamp={message.receiveMessage.timestamp}
            doctorName={message.receiveMessage.doctorName}
            doctorImage={message.receiveMessage.doctorImage}
            patientName={props.patientName}
        />
    });

    useEffect(scrollToBottom, [messages]);

    return (
        <div className={classes.chatcontent}>
            <div className={classes.chatcontainer}>
                {!props.loading_messages &&
                <ul className={classes.chat_ul}>
                    <li>
                        <ul className={classes.chat_main_ul}>
                            {messages}
                        </ul>
                        <div ref={messagesEndRef}/>
                    </li>
                </ul>
                }
                {props.loading_messages &&
                <div className={classes.no_loading}>
                    <div className={classes.no_loading_view}>
                        <div className={classes.loading_loader}/>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default ClinicalChatList;
